export enum EventChatWidgetKeys {
  CLOSE_CHAT = 'CLOSE_CHAT',
  SCHEDULE_MEETING = 'SCHEDULE_MEETING',
  RESCEDULE = 'RESCEDULE',
  OPEN_PROFILE = 'OPEN_PROFILE',
  CANCEL_MEETING = 'CANCEL_MEETING',
  OPEN_HELPDESK = 'OPEN_HELPDESK',
  SEND_VCARD = 'SEND_VCARD',
  CANCEL_VIDEO_MEETING = 'CANCEL_VIDEO_MEETING',
  CREATE_VIDEO_MEETING = 'CREATE_VIDEO_MEETING',
  ERROR_MESSAGE = 'ERROR_MESSAGE',
  CHAT_INITIALIZED = 'CHAT_INITIALIZED',
  UNREAD_COUNT = 'UNREAD_COUNT',
  JUBLIA_AI_CTA = 'JUBLIA_AI_CTA',
}

export enum TypeOfScheduleMeeting {
  COMPANY = 'company',
  PEOPLE = 'people',
}

export enum TabOfScheduleMeeting {
  MY_COMPANY = 'my_company',
  ME = 'me',
}

export enum TypeOfOpenProfile {
  COMPANY = 'company',
  ME = 'me',
}

export enum FlagPerformanceSnapshots {
  EXPORT = 'EXPORT',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  RATE = 'RATE',
}
